// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:17:26

export default {
  "id": "real-gt-racing-simulator",
  "slug": "real-gt-racing-simulator",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cf1e51dd543f417296a4cd4369784c63-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cf1e51dd543f417296a4cd4369784c63/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Real GT Racing Simulator",
      "description": "\"Real GT Racing Simulator\" offers the ultimate driving experience for racing enthusiasts. Get behind the wheel of meticulously detailed cars and race on stunningly realistic tracks. Compete in high-speed circuits, fine-tune your vehicle for peak performance, and rise through the ranks to become a true racing legend. This game emphasizes authentic driving physics, customizable cars, and a variety of racing modes—from casual races to full championship tournaments.",
      "instructions": "WASD/Arrow keys - move\nspace - brake\nshift - boost\nR - reposition",
      "genres": [
        "Racing & Driving",
        "Simulation"
      ],
      "tags": [
        "car",
        "drift",
        "realistic",
        "singleplayer",
        "speed"
      ]
    },
    "zh-CN": {
      "title": "真实GT赛车模拟器",
      "description": "\"Real GT Racing Simulator\"为赛车爱好者提供终极驾驶体验。驾驶精心打造的详细车辆，在令人惊叹的逼真赛道上竞技。在高速赛道上比赛，调整你的车辆以实现最佳性能，并通过排名提升成为真正的赛车传奇。此游戏强调真实的驾驶物理，可定制的车辆和多种赛车模式——从休闲比赛到完整锦标赛。",
      "instructions": "WASD/方向键 - 移动\n空格 - 刹车\nShift - 加速\nR - 重新定位",
      "genres": [
        "赛车与驾驶",
        "模拟"
      ],
      "tags": [
        "汽车",
        "漂移",
        "真实",
        "单人",
        "速度"
      ]
    },
    "zh-TW": {
      "title": "真實GT賽車模擬器",
      "description": "\"真實GT賽車模擬器\"為賽車愛好者提供最終的駕駛體驗。坐進細膩刻畫的車輛，在驚人的真實賽道上競速。在高速賽道競賽，精細調校你的車輛以達到最佳性能，並通過等級攀升成為真正的賽車傳奇。這款遊戲強調真實的駕駛物理學、可自定義的車輛以及各種賽車模式——從休闲賽到完整的冠軍賽事。",
      "instructions": "WASD/箭頭鍵 - 移動\n空格鍵 - 刹車\nShift - 加速\nR - 重置位置",
      "genres": [
        "賽車與駕駛",
        "模擬"
      ],
      "tags": [
        "車輛",
        "漂移",
        "真實",
        "單人遊戲",
        "速度"
      ]
    },
    "zh-HK": {
      "title": "真實GT賽車模擬器",
      "description": "《真實GT賽車模擬器》為賽車愛好者提供最終的駕駛體驗。駕馭細膩詳盡的車輛，在驚艷逼真的賽道上競速。在高速賽道中競爭，精細調校你的愛車以達到最佳性能，並逐漸升級成為真正的賽車傳奇。本遊戲強調真實的駕駛物理學、可自定義的車輛，以及各種賽車模式——從輕鬆比賽到完整的錦標賽賽事。",
      "instructions": "WASD/箭頭鍵 - 移動\n空格 - 刹車\nShift - 加速\nR - 重新定位",
      "genres": [
        "賽車及駕駛",
        "模擬"
      ],
      "tags": [
        "車",
        "漂移",
        "真實",
        "單人遊戲",
        "速度"
      ]
    },
    "ja": {
      "title": "リアルGTレーシングシミュレーター",
      "description": "“Real GT Racing Simulator”はレースファンにとって究極の運転体験を提供します。細部にわたって作り込まれた車を操車し、驚くほどリアルなトラックでレースを楽しみましょう。高速コースで競い合い、車を最適化して最高性能を引き出し、ランクを上がってレースの真の伝説になることを目指してください。このゲームは、本格的なドライビング物理、カスタマイズ可能な車両、カジュアルレースからフルチャンピオンシップトーナメントまでの多様なレースモードを強調しています。",
      "instructions": "WASD/矢印キー - 移動\nスペース - ブレーキ\nシフト - ブースト\nR - 位置再設定",
      "genres": [
        "レーシング & ドライビング",
        "シミュレーション"
      ],
      "tags": [
        "車",
        "ドリフト",
        "リアルistic",
        "シングルプレイヤー",
        "スピード"
      ]
    },
    "ko": {
      "title": "실제 GT 레이싱 시뮬레이터",
      "description": "\"Real GT Racing Simulator\"은 레이싱 팬들을 위한 최상의 운전 경험을 제공합니다. 구체적으로 설명된 차량에 탑승하고 놀라운现实主义의 트랙에서 레이스를 해보세요. 고속 루프에서 경쟁하고, 차량을 최적의 성능을 위해 세세하게 조정하며, 실제 레이싱 전설이 되기 위해 등級을 올리세요. 이 게임은 정직한 운전 물리학, 맞춤형 차량, 캐주얼 레이스에서 완전한 챔피언십 토너먼트까지 다양한 레이싱 모드를 강조합니다.",
      "instructions": "WASD/아이콘 키 - 이동\n스페이스바 - 브레이크\nShift - 보스터\nR - 재위치",
      "genres": [
        "레이싱 & 드라이빙",
        "시뮬레이션"
      ],
      "tags": [
        "차",
        "드리프트",
        "현실적",
        "싱글플레이어",
        "속도"
      ]
    },
    "fr": {
      "title": "Simulateur de Course GT Réel",
      "description": "\"Real GT Racing Simulator\" offre l'expérience de conduite ultime pour les passionnés de courses. Prenez le volant de voitures détaillées avec soin et coursez sur des circuits époustouflants. Competez dans des circuits à haute vitesse, affinez votre véhicule pour une performance optimale, et grimpez dans les rangs pour devenir une véritable légende de la course. Ce jeu met l'accent sur la physique de conduite authentique, des voitures personnalisables et une variété de modes de course - allant des courses occasionnelles aux tournois de championnat complets.",
      "instructions": "WASD/Touches directionnelles - se déplacer\nespace - freinage\nmaj - boost\nR - repositionner",
      "genres": [
        "Course et conduite",
        "Simulation"
      ],
      "tags": [
        "voiture de course",
        "drift",
        "réaliste",
        "mode solo",
        "vitesse"
      ]
    }
  }
};
